import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  sidebarContent: {
    display: "flex",
    flexDirection: "column",
    paddingTop: "8px",
    marginLeft: "24px",
    marginRight: "24px",
  },
  publicationSummary: {
    display: "flex",
    flexDirection: "column",
    width: "280px",
  },
  publicationTextSummary: {
    marginTop: "12px",
  },
  publicationStatus: {
    marginTop: "16px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  mt16: {
    marginTop: "16px",
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "8px",
    marginTop: "8px",
  },
  divider: {
    paddingRight: "24px",
    marginTop: "16px",
    marginBottom: "8px",
  },
  urlField: {
    width: "100%",
  },
  statusLabel: {
    color: capitalDesignTokens.semanticColors.foreground.secondary,
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium,
  },
});
